import { render, staticRenderFns } from "./ywlx.vue?vue&type=template&id=ef1ff1f0&scoped=true&"
import script from "./ywlx.vue?vue&type=script&lang=js&"
export * from "./ywlx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1ff1f0",
  null
  
)

export default component.exports